import React from 'react';
import clsx from 'clsx';
import { IconCheck } from '@maiia/design-system';

export type CheckboxProps = {
  className?: string;
  label?: string | JSX.Element;
  variant?: 'reverse' | 'full';
} & JSX.IntrinsicElements['input'];

const Checkbox = ({ className, variant, label, ...rest }: CheckboxProps) => {
  const _className = clsx(className, 'checkbox', variant && `is-${variant}`);

  return (
    <span className={_className}>
      <label className="label">
        {label}
        <input className="label__checkbox" type="checkbox" {...rest} />
        <span className="label__check">
          <IconCheck aria-hidden="true" />
        </span>
      </label>
    </span>
  );
};

export default Checkbox;
